import { render, staticRenderFns } from "./scope31.vue?vue&type=template&id=074f7f2a&scoped=true"
import script from "./scope31.vue?vue&type=script&lang=js"
export * from "./scope31.vue?vue&type=script&lang=js"
import style0 from "./scope31.vue?vue&type=style&index=0&id=074f7f2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074f7f2a",
  null
  
)

export default component.exports